import { useSelector } from 'react-redux'
import {
  type Constant,
  SpayedNeuteredField as SpayedNeuteredFieldComponent,
  type SpayedNeuteredFieldProps,
} from '@pbt/pbt-ui-components'

import { getGender } from '~/store/reducers/constants'

const SpayedNeuteredField = (
  props: Omit<SpayedNeuteredFieldProps, 'Gender'>,
) => {
  const Gender: Constant[] = useSelector(getGender)

  return <SpayedNeuteredFieldComponent Gender={Gender} {...props} />
}

export default SpayedNeuteredField
